import Util from '../util';

const util = new Util();

export default class topKv {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.TYPE = [
            "event","concert","marketing","tvradio","web",
            // "concert","concert","concert","concert","concert",
            "nomotion_book","nomotion_cafe","nomotion_ceremony","nomotion_goods","nomotion_sports",
        ];

        this.illust = {
            NUM : 4,
            type :this.TYPE,
            float :[],
            speed :[],
            start :[],
            now :[],
            select : [], /* 選択したものを保持 */
            selected : [], /* 選択済みを保持して弾くhajiku */
        };

        this.$target = $(".p-kv-bg-illust");

        this.count =[];

        for(let i=0; this.illust.NUM>i; i++){

            this.count[i] = 0;


            let _selectNum = util.rand(-1,this.illust.type.length);

            this.illust.select[i] = this.illust.type[ _selectNum ];
            this.illust.type.splice(_selectNum,1);
            this.$target.eq(i).addClass("p-kv-illust-"+this.illust.select[i]);
            this.$target.eq(i).find(".p-kv-bg-illust-icon img").attr("src","assets/img/top/kv/"+this.illust.select[i]+".gif")
            this.$target.eq(i).find(".p-kv-bg-illust-bg img").attr("src","assets/img/top/kv/"+this.illust.select[i]+"_bg.svg")


            // if(){
            //     this.illust.start.selected[i] = this.illust.start.select[i]
            // }else{
            //
            // }
            let _d = i/this.illust.NUM;
            let _y = {
                start : this.h*(1.7 + (4 *_d)),
                end : (Useragnt.pc)? this.h*(0.8 + (3 * _d)):this.h*(1.5 + (2 * _d))*1.5
            }


            this.illust.start[i]={
                y:util.rand(_y.start,_y.end)
            }

            this.illust.speed[i]=util.rand(180,260);
            this.illust.float[i]=util.rand(20,60);

            TweenMax.set(this.$target.eq(i),{
                // x:util.rand(0,this.w/1.5),
                y:this.illust.start[i].y
            });
        }

    }

    render(mouse){


        for(let i=0; this.illust.NUM>i; i++){

            this.count[i] += 0.01;


            this.illust.now[i] = {
                y : this.illust.start[i].y - this.count[i]*this.illust.speed[i],
            }

            TweenMax.set(this.$target.eq(i),{
                x: - Math.sin(this.count[i])*this.illust.float[i],
                y: this.illust.now[i].y,
            });


            if(-this.h > this.illust.now[i].y){


                if(this.count[i]!==0){
                    let _selectNum = util.rand(-1,this.illust.type.length);

                    this.$target.eq(i).removeClass("p-kv-illust-"+this.illust.select[i]);
                    this.illust.select[i] = this.illust.type[ _selectNum ];
                    this.$target.eq(i).addClass("p-kv-illust-"+this.illust.select[i]);
                    this.$target.eq(i).find(".p-kv-bg-illust-icon img").attr("src","assets/img/top/kv/"+this.illust.select[i]+".gif")
                    this.$target.eq(i).find(".p-kv-bg-illust-bg img").attr("src","assets/img/top/kv/"+this.illust.select[i]+"_bg.svg")
                    this.illust.type.splice(_selectNum,1);



                    if(this.illust.type.length===0){
                        this.illust.type = [
                            "event","concert","marketing","tvradio","web",
                            // "concert","concert","concert","concert","concert",
                            "nomotion_book","nomotion_cafe","nomotion_ceremony","nomotion_goods","nomotion_sports",
                        ];
                    }
                }

                this.count[i] = 0;

            }

        }


    }

    resize(){
        this.w = window.innerWidth;
        this.h = window.innerHeight;
        for(let i=0; this.illust.NUM>i; i++){
            let _d = i/this.illust.NUM;
            let _y = {
                start : this.h*(1.7 + (4 *_d)),
                // end : (Useragnt.pc)? this.h*(1.5 + (2 * _d)):this.h*(1.5 + (2 * _d))*1.5
                end : (Useragnt.pc)? this.h*(0.8 + (3 * _d)):this.h*(1.5 + (2 * _d))*1.5
            }

            this.illust.start[i].y = util.rand(_y.start,_y.end);
        }


    }
}